import { ApiRequest } from "GlobalFunctions";
import setSummary from '../../Orders/getOrderDetails';
import getOrderDetails from "../../Orders/getOrderDetails";
/*========================================================
GET TAXES
========================================================*/
export const getTaxes = async () => {
    
    const cart = JSON.parse(localStorage.getItem('cart') || '{}');

    await ApiRequest({
        url: '/taxes/getTaxes',
        method: 'POST',
        body: {
            cart
        },
        setResponse: (response: any) => {
            if (response.status === 'success') {
                // Update each product with its tax information
                const updatedCart = {...cart};
                
                if (updatedCart.products && response.products) {
                    updatedCart.products = updatedCart.products.map((product: any) => {
                        // Find the corresponding product from the response
                        const taxedProduct = response.products.find(
                            (p: any) => p.order_product_id === product.order_product_id
                        );
                        
                        if (taxedProduct) {
                            return {
                                ...product,
                                product_tax: taxedProduct.product_tax,
                                tax_amount: taxedProduct.tax_amount
                            };
                        }
                        
                        return product;
                    });
                }

                const tax_rate = Number(response.tax_rate) || 0;
                const shipping_price = Number(updatedCart.shipping_price) || 0;
                const shippingTax = tax_rate * (shipping_price) / 100;
                
                updatedCart.tax_rate = tax_rate;
                updatedCart.total_tax = response.total_tax + shippingTax;
                
                // Update total price to include tax
                updatedCart.total_price_with_tax = (parseFloat(updatedCart.total_price) + updatedCart.total_tax).toFixed(2);
                
                // Save updated cart back to localStorage
                localStorage.setItem('cart', JSON.stringify(updatedCart));
                getOrderDetails("checkout");
                
                return updatedCart;
            } else {
                console.error('Error calculating taxes:', response.message);
                return cart;
            }
        }
    });
}